const _ = require('lodash'); // GeoCoordinate


class Coordinate {
  // FIXME: use [long: number, lat: number] only once object format stops coming back from elasticsearch
  constructor(coordinateJson
  /*: any*/
  ) {
    if (_.isArray(coordinateJson)) {
      this.long = coordinateJson[0];
      this.lat = coordinateJson[1];
    } else {
      this.long = coordinateJson.lon;
      this.lat = coordinateJson.lat;
    }
  }

  serialize()
  /*: { lat: number, lon: number }*/
  {
    return {
      lat: this.lat,
      lon: this.long
    };
  }

}

module.exports = Coordinate;